<template>
  <div  class="wifi">
    <appHeader activeIndex="wifi"></appHeader>
    <div class="wifiContent">
      <img class="banner" src="../../assets/img/products/wifi/banner.png" alt />

        <div class="wifiIntroduction">
          <div class="wifiInfo">
            <div class="wifiInfo1">
            <img class="wifiInfo1Img1" src="../../assets/img/Product/wifi.png"  alt />
            <br><br><br><br><br>
            <img class="wifiInfo1Img2"  src="../../assets/img/products/wifi/wifiQRcode.png" alt />
            <div>扫码下载体验</div>     
          </div>
          <div class="wifiInfo2">
            <div class="productTitle">
              手机WiFi管家
            </div>
            一键上网更高效
            <br><br>
            <p>【WIFI一键链接】为您保存已添加WiFi密码，告知WiFi强弱，点击无线WiFi，一键即可链接!</p>
            <p>【优质WiFi首推】为您优先推荐高质量WiFi，屏蔽无用WiFi，让您上网更加安全可靠。!</p>
            <p>【网络安全检测】检测您的手机用网安全，提示已连接网络详细信息，信号强弱，让您放心上网!!</p>
            <p>【网速测试服务】为您的手机测试网络速度，包含:网络延时、上传速度、下载速度、让您随时了解手机情况。!!</p>
            <p>【垃圾清理功能】检测您的手机垃圾，为您清理多余安装包、广告垃圾、缓存垃圾等，让您手机运转如飞。!!</p>
          </div>
          <div style="clear: both;"></div> 
          </div>
          <div class="dividingLine">
          </div>
          <div class="wifiCarousel">
            <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="wifiWrap">
            <img class="wifiMainImg" :style="{ left: nowLeft + '%' }" src="../../assets/img/products/wifi/carousel.png" alt />
          </div>
          </div>
      </div>
    </div>
        <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,
    appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +14
      },

      right() {
        if(this.nowLeft <= -14){
          return;
        }
        this.nowLeft = this.nowLeft -14
      }
  }
};
</script>
<style>
@import "../../assets/css/products/product.css";
@import "../../assets/css/products/wifi.css";

</style>
